import CSSStyle from '../StripePayment/index.module.css';
import React, { useState, useCallback, useEffect } from "react";
import { JoinClassName } from '../utils/cssHelper';
import { FormattedMessage } from 'react-intl';
import { CardPaymentMethodInfo, PaymentRequestInfo } from '../model';
import { DisplayFormatEnum, numberFormat } from '../utils/utils';

export type CreditCardPaymentPanelProps = {
    onDoCreditCardPayment: (creditCardPaymentMethodInfo: CardPaymentMethodInfo) => void;
    onAddCreditCardRequest: () => void;
    onChangeCreditCardRequest: () => void;
    cardPaymentMethodInfo: CardPaymentMethodInfo | null;
    paymentRequestInfo: PaymentRequestInfo;
    showAsPopUp?: boolean;
    onCancelCreditCardPayment?: () => void;
}
export function CreditCardPaymentPanel(props: CreditCardPaymentPanelProps) {

    let {
        paymentRequestInfo,
        cardPaymentMethodInfo,
        showAsPopUp = false,
        onCancelCreditCardPayment,
    } = props;
    let [creditCardReady, setCreditCardReady] = useState<CardPaymentMethodInfo | null>(cardPaymentMethodInfo);
    let totalPaymentAmount = paymentRequestInfo.payAmount;
    let payButtonEnable = Math.ceil(paymentRequestInfo.payAmount) > 0;

    let getCardBrandIcon = useCallback((cardBrandName: string) => {
        // amex, diners, discover, jcb, mastercard, unionpay, visa, or unknown
        switch (cardBrandName) {
            case 'visa': {
                return CSSStyle.visa;
            }
            case 'amex': {
                return CSSStyle.americanexpress;
            }
            case 'discover': {
                return CSSStyle.discover;
            }
            case 'jcb': {
                return CSSStyle.jcb;
            }
            case 'mastercard': {
                return CSSStyle.master;
            }
            case 'unionpay': {
                return CSSStyle.unionpay;
            }
            default: {
                return "";
            }
        }
    }, []);

    let onSelectPayemntMethod = useCallback(() => {
        props.onChangeCreditCardRequest();
    }, [props]);


    let onAddCreditCard = useCallback(() => {
        props.onAddCreditCardRequest();
    }, [props]);

    let onDoCreditCardPayment = useCallback(() => {
        creditCardReady && props.onDoCreditCardPayment(creditCardReady);
    }, [creditCardReady]);

    useEffect(() => {
        setCreditCardReady(props.cardPaymentMethodInfo);
    }, [props])

    let onCancel = useCallback(() => {
        console.log('onCancel', onCancelCreditCardPayment);
        onCancelCreditCardPayment && onCancelCreditCardPayment();
    }, [onCancelCreditCardPayment]);

    let getHeader = (showAsPopUp: boolean) => {
        return <React.Fragment>
            {
                showAsPopUp && <React.Fragment>
                    <div className={JoinClassName(CSSStyle.header)} >
                        <div className={JoinClassName(CSSStyle.cancle_operator)} onClick={onCancel}></div>
                        {/* <div className={JoinClassName(CSSStyle.balance_amount)}>
                            <FormattedMessage id="balance_amount" values={{ paymentAmount: numberFormat((totalPaymentAmount || 0) / 100, DisplayFormatEnum.DECIMAL, 2) }}></FormattedMessage>
                        </div> */}
                    </div>
                </React.Fragment>

            }
        </React.Fragment>
    }
    return (<div className={JoinClassName(showAsPopUp ? CSSStyle.creditcard_payment_panel_mainPopup : CSSStyle.main,)}>

        {/***build credit card payment */}
        {
            !creditCardReady && (
                <React.Fragment>
                    <div className={JoinClassName(CSSStyle.main)}>
                        {
                            getHeader(showAsPopUp)
                        }
                        <div className={JoinClassName(CSSStyle.credit_card_pay_container)}>
                            <div className={JoinClassName(CSSStyle.credit_card_pay_card)}>
                                <div className={JoinClassName(CSSStyle.credit_card_pay_card_header)} >
                                    <FormattedMessage id="payment_method_title"></FormattedMessage>
                                </div>
                                <div className={JoinClassName(CSSStyle.credit_card_pay_selected_card)} >
                                    <i className={CSSStyle.flexHolder}></i>
                                    <div className={JoinClassName(CSSStyle.operation)} onClick={onAddCreditCard} >
                                        <FormattedMessage id="add_your_card_here_title"></FormattedMessage>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <i className={JoinClassName(CSSStyle.flexHolder)}></i>
                        <div className={JoinClassName(CSSStyle.credit_payment_button_container)}>
                            <div className={JoinClassName(CSSStyle.credit_payment_button)} onClick={onAddCreditCard}>
                                <FormattedMessage id="confirm_and_pay_button_no_card" values={{ paymentAmount: numberFormat((totalPaymentAmount || 0) / 100, DisplayFormatEnum.DECIMAL, 2) }}></FormattedMessage>
                            </div>
                        </div>
                    </div>
                </React.Fragment>
            )
        }

        {
            creditCardReady && (
                <React.Fragment>
                    <div className={JoinClassName(CSSStyle.main)}>
                        {
                            getHeader(showAsPopUp)
                        }
                        <div className={JoinClassName(CSSStyle.credit_card_pay_container)}>
                            <div className={JoinClassName(CSSStyle.credit_card_pay_card)}>
                                <div className={JoinClassName(CSSStyle.credit_card_pay_card_header)} >
                                    {/* 支付方式 */}
                                    <FormattedMessage id="payment_method_title"></FormattedMessage>
                                </div>
                                <div className={JoinClassName(CSSStyle.credit_card_pay_selected_card)} >

                                    <div className={JoinClassName(CSSStyle.selected_card_desc)} >
                                        {/* {creditCardReady.card.brand} */}
                                        <div className={JoinClassName(CSSStyle.card_brand_icon, getCardBrandIcon(creditCardReady.card.brand))}></div>

                                        <div className={JoinClassName(CSSStyle.card_last4)}>ending in {creditCardReady.card.last4}</div>
                                    </div>

                                    <div className={JoinClassName(CSSStyle.operation)} onClick={onSelectPayemntMethod}>
                                        {/* 更改支付方式 */}
                                        <FormattedMessage id="change_payment_method_title"></FormattedMessage>
                                    </div>

                                </div>
                            </div>
                        </div>
                        <i className={JoinClassName(CSSStyle.flexHolder)}></i>
                        <div className={JoinClassName(CSSStyle.credit_payment_button_container)}>
                            <div className={JoinClassName(CSSStyle.credit_payment_button, payButtonEnable ? '' : CSSStyle.disable)} onClick={onDoCreditCardPayment}>
                                {/* 确认并支付 • $207.00 */}
                                <FormattedMessage id="confirm_and_pay_button" values={{ paymentAmount: numberFormat((totalPaymentAmount || 0) / 100, DisplayFormatEnum.DECIMAL, 2) }}></FormattedMessage>
                            </div>
                        </div>
                    </div>
                </React.Fragment>
            )
        }
    </div>);
}